import { initializeApp } from "firebase/app";
import { getFirestore } from 'firebase/firestore/lite';

const firebaseConfig = {
  apiKey: "AIzaSyBj8Lb-6CU7F4YYKPs2sn-434YlKaLUbzc",
  authDomain: "quitocultural-a4e91.firebaseapp.com",
  projectId: "quitocultural-a4e91",
  storageBucket: "quitocultural-a4e91.firebasestorage.app",
  messagingSenderId: "487865649538",
  appId: "1:487865649538:web:93124a19096f9c2025279b",
  measurementId: "G-6DRCXBSFT4"
};

// Initialize Firebase
const appFB = initializeApp(firebaseConfig);
export const dbFB = getFirestore(appFB);
